// Kit-Hierarchie und Positionsnummern — aus `recomputeKitParents` (Original 821)
// und `posLabels` (833). Filter und Sortierung der Ansicht ändern die Nummern
// NICHT; sie hängen an der Reihenfolge im Beleg.

/** Menge der Positions-IDs, die Unterpositionen tragen (Set-Köpfe). */
export function kitParentIds(rows) {
    return new Set((rows || []).filter((r) => r.parentItemId).map((r) => String(r.parentItemId)));
}

export function isKitParent(r, kitParents) {
    return !!(r && r.id != null && kitParents.has(String(r.id)));
}

export function isKitChild(r) {
    return !!(r && r.parentItemId);
}

/**
 * Hierarchische Positionsnummern wie in weclapp: oberste Ebene 1, 2, 3 …,
 * Set-Unterpositionen <Kopf>.<lfd> (4.1, 4.2 …). Indiziert nach der Position
 * in `rows`.
 */
export function posLabels(rows) {
    const out = new Array(rows.length);
    const topOf = {};
    const childCnt = {};
    let top = 0;

    rows.forEach((r, i) => {
        if (!isKitChild(r)) {
            top++;
            out[i] = String(top);
            if (r.id != null) {
                topOf[String(r.id)] = top;
            }
        }
    });

    rows.forEach((r, i) => {
        if (isKitChild(r)) {
            const p = String(r.parentItemId);
            childCnt[p] = (childCnt[p] || 0) + 1;
            out[i] = (topOf[p] != null ? topOf[p] : '?') + '.' + childCnt[p];
        }
    });

    return out;
}

/**
 * Arbeitszustand je Position: der geladene Stand plus `_orig` als Grundlage
 * für die Änderungserkennung.
 *
 * `itemOverrides` ist der im Ordermanagement gespeicherte Arbeitsstand
 * (`order_editor_states.item_overrides`) — heute ausschließlich die Wahl
 * „Keine Lieferung". Sie wird als AUSGANGSSTAND übernommen und nicht als
 * offene Änderung: der Wert ist bereits gespeichert, sonst stünde nach jedem
 * Laden eine ungespeicherte Änderung im Raum (ABGLEICH H34).
 *
 * @param {object[]} items - Positionen aus `/load`.
 * @param {Object<string, string>} [itemOverrides] - `{itemId: 'none'}`.
 */
export function toEditorRows(items, itemOverrides) {
    const overrides = itemOverrides || {};

    return (items || []).map((it) => {
        const gespeichert = it.id != null ? overrides[String(it.id)] : undefined;
        const stamm = gespeichert || it.stammOverride || null;

        return {
            ...it,
            _stammOverride: stamm,
            _orig: JSON.stringify({
                quantity: it.quantity,
                discountPercentage: it.discountPercentage,
                stammOverride: stamm,
            }),
        };
    });
}

/**
 * Schlüssel einer neu hinzugefügten Zeile. Neue Positionen haben noch keine
 * weclapp-Kennung; ohne eigenen Schlüssel verlören die Eingabefelder beim
 * Umsortieren ihren Platz.
 */
let neueZeilen = 0;

export function nextNewRowKey() {
    neueZeilen += 1;
    return `neu-${neueZeilen}`;
}
